import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-admininffivi',
  templateUrl: './admininffivi.component.html',
  styleUrls: ['./admininffivi.component.css']
})
export class AdmininffiviComponent implements OnInit {

  constructor(
    private router:Router
  ) { }

  ngOnInit(): void {
  }

  RegresarAdminInf(){
    this.router.navigate(['admininfo']);
  }

  IrConsultaInformacion(){
    this.router.navigate(['consultarinfofivi']);
  }

  IrCargueMasivoInformacion(){
    this.router.navigate(['carguemasivoinfofivi']);
  }

  IrActivarCargue(){
    this.router.navigate(['activarcarguefivi']);
  }

  IrCrearNovedad(){
    this.router.navigate(['crearnovedadfivi']);
  }

}
